var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 10.8333C1.66602 11.4899 1.79534 12.1401 2.04662 12.7468C2.29789 13.3534 2.66619 13.9046 3.13048 14.3689C3.59477 14.8332 4.14597 15.2015 4.7526 15.4527C5.35923 15.704 6.00941 15.8333 6.66602 15.8333C7.32262 15.8333 7.9728 15.704 8.57943 15.4527C9.18606 15.2015 9.73726 14.8332 10.2015 14.3689C10.6658 13.9046 11.0341 13.3534 11.2854 12.7468C11.5367 12.1401 11.666 11.4899 11.666 10.8333C11.666 9.94928 11.3148 9.10143 10.6897 8.47631C10.0646 7.85119 9.21674 7.5 8.33268 7.5C7.44863 7.5 6.60078 7.85119 5.97566 8.47631C5.35054 9.10143 4.99935 9.94928 4.99935 10.8333C4.99935 11.2754 5.17494 11.6993 5.4875 12.0118C5.80006 12.3244 6.22399 12.5 6.66602 12.5C7.10804 12.5 7.53197 12.3244 7.84453 12.0118C8.15709 11.6993 8.33268 11.2754 8.33268 10.8333M1.66602 10.8333C1.66602 14.5152 4.65078 17.5 8.33268 17.5C12.0146 17.5 14.9993 14.5152 14.9993 10.8333M1.66602 10.8333C1.66602 7.15143 4.65078 4.16667 8.33268 4.16667C12.0146 4.16667 14.9993 7.15143 14.9993 10.8333M14.9993 10.8333V5.83333C14.9993 5.39131 15.1749 4.96738 15.4875 4.65482C15.8001 4.34226 16.224 4.16667 16.666 4.16667C17.108 4.16667 17.532 4.34226 17.8445 4.65482C18.1571 4.96738 18.3327 5.39131 18.3327 5.83333V10.8333C18.3327 14.5 15.3327 17.5 11.666 17.5H1.66602M14.9993 2.5L15.916 4.33333M18.3327 2.5L17.416 4.33333",
    stroke: "#79F9D0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnail);
export default __webpack_public_path__ + "static/media/snail.c4a741bb0e154fc56250176c5d910e2e.svg";
export { ForwardRef as ReactComponent };